var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"load"},[_c('van-loading',{attrs:{"size":"25px","type":"spinner","text-size":"15px","color":"#e62d2d"}},[_vm._v("加载中...")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.textFlag),expression:"textFlag"}]},[_vm._v(_vm._s(_vm.textContent))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }